export default {"src":"/_next/static/media/register.35ec26b7.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};